module.exports = __webpack_public_path__ + "static/media/ilustration-signup-invited.79bfa461.png";